var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Box } from '@creditas-ui/layout';
import { css, styled } from '@creditas-ui/system';
import { selectTheme, variant } from '@creditas-ui/utilities';

var base = _ref => {
  var {
    theme: {
      avatar
    }
  } = _ref;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  border-radius: ", ";\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  vertical-align: top;\n"])), avatar('base.borderRadius'));
};

var sizes = _ref2 => {
  var {
    theme: {
      avatar
    }
  } = _ref2;
  return variant({
    prop: 'size',
    variants: {
      xs: {
        height: "".concat(avatar('base.sizes.xs')),
        width: "".concat(avatar('base.sizes.xs'))
      },
      sm: {
        height: "".concat(avatar('base.sizes.sm')),
        width: "".concat(avatar('base.sizes.sm'))
      },
      md: {
        height: "".concat(avatar('base.sizes.md')),
        width: "".concat(avatar('base.sizes.md'))
      },
      lg: {
        height: "".concat(avatar('base.sizes.lg')),
        width: "".concat(avatar('base.sizes.lg'))
      },
      xl: {
        height: "".concat(avatar('base.sizes.xl')),
        width: "".concat(avatar('base.sizes.xl'))
      }
    }
  });
};

var variantStyles = variant({
  variants: {
    contained: {
      borderStyle: 'none'
    },
    outlined: {
      background: 'none',
      borderStyle: 'solid',
      borderWidth: '1px'
    },
    text: {
      background: 'none',
      borderStyle: 'none'
    }
  }
});

var backgroundVariantsStyles = _ref3 => {
  var {
    theme: {
      avatar
    }
  } = _ref3;
  return variant({
    variants: {
      light: {
        backgroundColor: avatar('light.backgroundColor')
      },
      dark: {
        backgroundColor: avatar('dark.backgroundColor')
      }
    }
  });
};

var AvatarImage = styled(Box.withComponent('img', process.env.NODE_ENV === "production" ? {
  target: "e1r7w1it0"
} : {
  target: "e1r7w1it0",
  label: "AvatarImage"
}))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  border-radius: ", ";\n  z-index: 1;\n"])), selectTheme('radius.round'));
var BackgroundColor = styled(Box)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  ", "\n  ", "\n"])), backgroundVariantsStyles, _ref4 => {
  var {
    theme: {
      avatar
    }
  } = _ref4;
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    border-radius: ", ";\n    opacity: ", ";\n  "])), avatar('base.borderRadius'), avatar('base.opacity'));
});
var AvatarElement = styled(Box.withComponent('span', process.env.NODE_ENV === "production" ? {
  target: "e1r7w1it1"
} : {
  target: "e1r7w1it1",
  label: "AvatarElement"
}))(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n"])), base, sizes, variantStyles);
export { AvatarElement, AvatarImage, BackgroundColor };
//# sourceMappingURL=Avatar.style.js.map